import React from 'react';
import {Grid, Stack, Typography} from '@mui/material';
import {carbOptions} from '../constants/carbOptions';
import CustomCard from './customCard';
import Carousel from './carousel';
import _ from 'lodash';
import 'react-glidejs/dist/index.css';

const Recover = () => {
  const typesOfSupplements = _.groupBy(carbOptions, 'type');
  const recover = typesOfSupplements['recover'];

  return (
    <Stack>
      <Typography variant="h6">Recover from the workout</Typography>
      <Carousel>
        {recover.map((supp, index) => <CustomCard key={index} metadata={supp} />)}
      </Carousel>
    </Stack>
  );
};

export default Recover;
